function get(key) {
  try {
    return JSON.parse(localStorage.getItem(key));
  } catch (e) {
    return null;
  }
}

export function initPort(app) {
  app.ports.putCache &&
    app.ports.putCache.subscribe(function(x) {
      localStorage.setItem(x.key, JSON.stringify(x.value));
    });

  app.ports.getCache &&
    app.ports.getCache.subscribe(function(key) {
      app.ports.receiveCache &&
        app.ports.receiveCache.send({ key: key, value: get(key) });
    });
}
